"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.prepareCredentialRequestOptions = exports.prepareCredentialForRegistration = exports.prepareCredentialForAuthentication = exports.prepareCredentialCreationOptions = exports.isPasskeySupported = exports.isKnownPasskeyUser = exports.hasDeclinedPasskeySetup = exports.base64urlToArrayBuffer = exports.arrayBufferToBase64url = exports.IS_WEBAUTHN_SUPPORTED = void 0;
var _repeat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/repeat"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/map"));
var _constants = require("../constants");
/**
 * WebAuthn support detection - computed once at module load
 * Value is static during the entire page session
 */
const IS_WEBAUTHN_SUPPORTED = exports.IS_WEBAUTHN_SUPPORTED = !!(typeof window !== 'undefined' && window.PublicKeyCredential && window.navigator.credentials && window.navigator.credentials.get);

/**
 * Checks if WebAuthn is supported in the current browser
 *
 * @returns True if WebAuthn is supported
 */
const isPasskeySupported = () => {
  return IS_WEBAUTHN_SUPPORTED;
};

/**
 * Checks if the user is a known passkey user (has registered a passkey, or authenticated with a passkey previously)
 *
 * @returns True if the user is a known passkey user
 */
exports.isPasskeySupported = isPasskeySupported;
const isKnownPasskeyUser = () => {
  return localStorage.getItem(_constants.knownPasskeyUserLocalStorageKey) === 'true';
};

/**
 * Checks if the user has declined passkey setup
 *
 * @returns True if the user has declined passkey setup
 */
exports.isKnownPasskeyUser = isKnownPasskeyUser;
const hasDeclinedPasskeySetup = () => {
  return localStorage.getItem(_constants.hasDeclinedPasskeySetupLocalStorageKey) === 'true';
};

/**
 * Converts a base64url string to ArrayBuffer
 *
 * @param base64url - Base64url encoded string
 * @returns ArrayBuffer
 */
exports.hasDeclinedPasskeySetup = hasDeclinedPasskeySetup;
const base64urlToArrayBuffer = base64url => {
  var _context;
  const padding = (0, _repeat.default)(_context = '=').call(_context, (4 - base64url.length % 4) % 4);
  const base64 = base64url.replace(/-/g, '+').replace(/_/g, '/') + padding;
  const binaryString = atob(base64);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
};

/**
 * Converts ArrayBuffer to base64url string
 *
 * @param buffer - ArrayBuffer to convert
 * @returns Base64url encoded string
 */
exports.base64urlToArrayBuffer = base64urlToArrayBuffer;
const arrayBufferToBase64url = buffer => {
  const bytes = new Uint8Array(buffer);
  let binaryString = '';
  for (const byte of bytes) {
    binaryString += String.fromCharCode(byte);
  }
  return btoa(binaryString).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
};

/**
 * Prepares WebAuthn credential creation options from server response
 *
 * @param options - Registration options from server
 * @returns PublicKeyCredentialCreationOptions for WebAuthn API
 */
exports.arrayBufferToBase64url = arrayBufferToBase64url;
const prepareCredentialCreationOptions = options => {
  return {
    challenge: base64urlToArrayBuffer(options.challenge),
    rp: options.rp,
    user: {
      ...options.user,
      id: base64urlToArrayBuffer(options.user.id)
    },
    pubKeyCredParams: options.pubKeyCredParams,
    authenticatorSelection: options.authenticatorSelection,
    timeout: options.timeout,
    attestation: options.attestation
  };
};

/**
 * Prepares credential data for server registration
 *
 * @param credential - WebAuthn credential from browser
 * @returns Formatted data for server registration matching design document structure
 */
exports.prepareCredentialCreationOptions = prepareCredentialCreationOptions;
const prepareCredentialForRegistration = credential => {
  const response = credential.response;
  return {
    id: arrayBufferToBase64url(credential.rawId),
    rawId: arrayBufferToBase64url(credential.rawId),
    response: {
      clientDataJSON: arrayBufferToBase64url(response.clientDataJSON),
      attestationObject: arrayBufferToBase64url(response.attestationObject),
      transports: response.getTransports?.() || []
    },
    type: 'public-key'
  };
};

/**
 * Prepares WebAuthn credential request options from server response for authentication
 *
 * @param options - Authentication options from server
 * @returns PublicKeyCredentialRequestOptions for WebAuthn API
 */
exports.prepareCredentialForRegistration = prepareCredentialForRegistration;
const prepareCredentialRequestOptions = options => {
  var _context2;
  return {
    challenge: base64urlToArrayBuffer(options.challenge),
    timeout: options.timeout,
    rpId: options.rpId,
    userVerification: options.userVerification,
    allowCredentials: (0, _map.default)(_context2 = options.allowCredentials).call(_context2, cred => ({
      type: cred.type,
      id: base64urlToArrayBuffer(cred.id),
      ...(cred.transports && {
        transports: cred.transports
      })
    }))
  };
};

/**
 * Prepares credential assertion data for server authentication
 *
 * @param credential - WebAuthn credential from browser
 * @param token - Challenge token from authentication start
 * @returns Formatted data for server authentication matching design document structure
 */
exports.prepareCredentialRequestOptions = prepareCredentialRequestOptions;
const prepareCredentialForAuthentication = (credential, token) => {
  const response = credential.response;
  return {
    token,
    assertion: {
      id: arrayBufferToBase64url(credential.rawId),
      rawId: arrayBufferToBase64url(credential.rawId),
      response: {
        clientDataJSON: arrayBufferToBase64url(response.clientDataJSON),
        authenticatorData: arrayBufferToBase64url(response.authenticatorData),
        signature: arrayBufferToBase64url(response.signature),
        ...(response.userHandle && {
          userHandle: arrayBufferToBase64url(response.userHandle)
        })
      },
      type: 'public-key'
    }
  };
};
exports.prepareCredentialForAuthentication = prepareCredentialForAuthentication;